
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import SingleImage1 from "@/components/content-management/single-image/SingleImage1.vue";
import SingleImage2 from "@/components/content-management/single-image/SingleImage2.vue";
import SingleImage4 from "@/components/content-management/single-image/SingleImage4.vue";

@Component({
  components: {
    SingleImage4,
    SingleImage2,
    SingleImage1,
  },
  filters,
})
export default class SingleImage extends Vue {
  @Prop({ default: 1 })
  private templateNumber!: number;
  @Prop({ default: null })
  private image!: any;
}
